import { useContext, createContext } from "react";

export type PrefetchedContent = {
  url: string;
  status?: number;
  content?: string;
  inlineStyleSheets?: boolean;
};

export const PrefetchContext = createContext<Record<string, PrefetchedContent>>(
  {}
);

export const usePrefetched = (name: string): PrefetchedContent | undefined => {
  const prefetchedData = useContext(PrefetchContext);
  // eslint-disable-next-line no-prototype-builtins
  return prefetchedData && prefetchedData.hasOwnProperty(name)
    ? prefetchedData[name]
    : undefined;
};
